// DS: C23
/** The footer used in most pages */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import classnames from 'classnames';
import { URLS } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import FacebookIcon from '@wix/da-ds/pkg/Icons/Facebook';
import InstagramIcon from '@wix/da-ds/pkg/Icons/Instagram';
import TwitterIcon from '@wix/da-ds/pkg/Icons/Twitter';
import Logo from '@wix/da-ds/pkg/Logo';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import ErrorBoundary from '../ErrorBoundary';
import s from './SiteFooter.scss';
var menuItems = [
    { key: 'siteFooter.menu.about', href: URLS.ABOUT, name: 'about' },
    { key: 'siteFooter.menu.contact', href: URLS.CONTACT, name: 'contact' },
    {
        key: 'siteFooter.menu.coreMembership',
        href: URLS.CORE_MEMBERSHIP,
        name: 'core_membership',
    },
    {
        key: 'siteFooter.menu.daProtect',
        mobileKey: 'siteFooter.menu.daProtect.mobile',
        href: "".concat(URLS.PROTECT, "?utm_source=DA&utm_medium=banner&utm_campaign=DA_footer&utm_id=DA_footer"),
        name: 'protect',
    },
    {
        key: 'siteFooter.menu.developers',
        href: URLS.DEVELOPERS,
        name: 'developers',
    },
    { key: 'siteFooter.menu.advertise', href: URLS.ADVERTISE, name: 'advertise' },
    {
        key: 'siteFooter.menu.termsOfService',
        href: URLS.TOS,
        name: 'terms_of_service',
    },
    { key: 'siteFooter.menu.etiquette', href: URLS.ETIQUETTE, name: 'etiquette' },
    { key: 'siteFooter.menu.careers', href: URLS.CAREERS, name: 'careers' },
    { key: 'siteFooter.menu.privacyPolicy', href: URLS.PRIVACY, name: 'privacy' },
    {
        key: 'siteFooter.menu.copyrightPolicy',
        href: URLS.COPYRIGHT,
        name: 'copyright',
    },
    { key: 'siteFooter.menu.helpAndFaq', href: URLS.HELP, name: 'help' },
];
var socialButtons = [
    {
        icon: FacebookIcon,
        href: 'https://www.facebook.com/deviantart/',
        title: 'DeviantArt Facebook',
        name: 'facebook',
    },
    {
        icon: InstagramIcon,
        href: 'https://www.instagram.com/deviantart/',
        title: 'DeviantArt Instagram',
        name: 'instagram',
    },
    {
        icon: TwitterIcon,
        href: 'https://twitter.com/DeviantArt',
        title: 'DeviantArt Twitter',
        name: 'twitter',
    },
];
var copyrightKey = 'siteFooter.copyright';
var allRightsReservedKey = 'siteFooter.allRightsReserved';
var SiteFooter = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var theme = useContext(ThemeContext);
    var isDarkTheme = theme === ThemeOptions.DARK;
    return (React.createElement("footer", { className: classnames(s['root'], className), role: "contentinfo" },
        React.createElement(ErrorBoundary, { debugComponent: "SiteFooter", hideOnFail: true },
            React.createElement("div", { className: s['columns'] },
                React.createElement("div", { className: classnames(s['logo-block'], s['column']) },
                    React.createElement(BiLink, { href: "https://deviantart.com/", title: "DeviantArt - Homepage", biData: BiData({
                            evid: 720,
                            link_name: 'logo',
                        }) },
                        React.createElement(VisuallyHidden, null, "DeviantArt - Homepage"),
                        React.createElement(Logo, { className: s['logo'], markColor: isDarkTheme ? 'white' : 'black', textColor: isDarkTheme ? 'white' : 'black', size: "tiny" }))),
                React.createElement("div", { className: classnames(s['multicolumn'], s['column']) }, menuItems.map(function (item) { return (React.createElement("div", { className: s['menu__block__item'], key: item.key },
                    React.createElement(BiLink, { className: s['link'], href: item.href, title: t(item.key), biData: BiData({
                            evid: 720,
                            link_name: item.name,
                        }) }, t(item.mobileKey && isMobile ? item.mobileKey : item.key)))); })),
                React.createElement("div", { className: classnames(s['social-block'], s['column']) },
                    React.createElement("div", { className: s['social-networks'] }, socialButtons.map(function (sb, index) { return (React.createElement(BiLink, { key: index, className: s['social-networks__button'], href: sb.href, title: sb.title, biData: BiData({
                            evid: 720,
                            link_name: sb.name,
                        }) },
                        React.createElement(VisuallyHidden, null, sb.title),
                        React.createElement(sb.icon, { size: IconSize.MEDIUM, className: classnames(s['social-networks__icon'], s['link']) }))); }))),
                isMobile && (React.createElement("div", { className: s['copyright'] },
                    React.createElement("div", null, t(copyrightKey, {
                        year: new Date().getFullYear(),
                    })),
                    React.createElement("div", { className: s['separator'] }),
                    React.createElement("div", null, t(allRightsReservedKey))))),
            !isMobile && (React.createElement("div", { className: s['copyright'] },
                React.createElement("div", null, t(copyrightKey, { year: new Date().getFullYear() })),
                React.createElement("div", null, t(allRightsReservedKey)))))));
};
SiteFooter.displayName = 'SiteFooter';
export default React.memo(SiteFooter);
//# sourceMappingURL=SiteFooter.js.map